import { helper } from '@ember/component/helper';

const makeArray = function (_params: void[], hash: { length: number }) {
	let length = hash.length;
	if (length < 0 || isNaN(length)) {
		length = 0;
	}

	return [...new Array(length + 1).keys()].slice(1); // fill it with numbers 1 to length
};

const makeArrayHelper = helper(makeArray);

export default makeArrayHelper;
